import React from 'react';
import { usePlanFeatures } from '../../contexts/PlanFeaturesContext';
import './styles.css';
import arrowRight from '../../images/arrowRight.svg';

const PopularSearch = ({
    title = "Popular searches",
    onSearchClick = () => {}
}) => {
    const { getPopularSearches, loading: planFeaturesLoading } = usePlanFeatures();
    
    // Get popular searches from plan features API
    const popularSearches = getPopularSearches();

    // Temporary fallback for local development/testing
    const isLocalDevelopment = window.location.hostname === 'localhost' || 
                                window.location.hostname === '127.0.0.1';
    
    const fallbackSearches = [
        { displayName: "Primary Care", value: "29PCP" },
        { displayName: "Pediatric", value: "29PED" },
        { displayName: "Dermatology", value: "29DERM" },
        { displayName: "Women's Health", value: "29WH" },
        { displayName: "Chiropractic", value: "29CHIRO" }
    ];
    
    // Use API data if available, otherwise use fallback in local dev
    const searchTerms = popularSearches.length > 0 
        ? popularSearches 
        : (isLocalDevelopment ? fallbackSearches : []);

    const handleCategoryClick = (searchItem) => {
        // Pass the entire search item object with displayName and value (psId)
        onSearchClick(searchItem);
    };

    // Don't render if plan features are still loading
    if (planFeaturesLoading) {
        return (
            <div id="popularSearch" className="mb30">
                <h3>{title}</h3>
                <div className="popular-search-row">
                    <span>Loading popular searches...</span>
                </div>
            </div>
        );
    }

    // Don't render if no popular searches are available
    if (searchTerms.length === 0) {
        return null;
    }

    return (
        <div id="popularSearch" className="mb30">
            <h3>{title}</h3>
            {/* A11y fix: this list of related search links was previously a plain <div>
                wrapping bare <a> tags — visually a list, but with no semantic list
                structure for assistive technology to recognize as a group. Screen reader
                users had no way to navigate item-to-item as a list, hear an announced
                item count ("list, 5 items"), or skip past the whole group at once the way
                they can with any other list on the page. Wrapping in <ul>/<li> (with the
                existing flex-row layout moved from .popular-search-row's <div> onto the
                <ul> itself — see styles.css) fixes this with no visual change. */}
            <ul className="popular-search-row">
                {searchTerms.map((searchItem, index) => (
                    <li key={`${searchItem.value}-${index}`}>
                        <a
                            href="#"
                            className="popular-search-link"
                            onClick={(e) => {
                                e.preventDefault();
                                handleCategoryClick(searchItem);
                            }}
                            aria-label={`Search for ${searchItem.displayName}`}
                        >
                            {searchItem.displayName}
                            <img
                                src={arrowRight}
                                alt=""
                                className="popular-search-arrow"
                            />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PopularSearch;
